﻿import {createBindings} from '../Questions/component-type-binding';

import {createNamespacedHelpers} from "vuex";

const {mapGetters} = createNamespacedHelpers('audienceManager/builder');

export default {
    name: "Category",
    
    //Invoke function to allow using Object.assign at a later point
    //without actually assigning properties to the exported object
    components: createBindings(),
    computed: {
        /**
         * @returns {boolean} Indicating whether category is loaded or not
         */
        categoryLoaded(){
            return !!this.categoriesValue()[this.categoryId];
        },

        /**
         * @returns {Object|undefined} category Category associated with the component's categoryId prop
         * @returns {string} category.name  Name of the category
         */
        category() {
            return this.categoriesValue()[this.categoryId];
        },

        /**
         * Obtain all active questions associated with the current category
         *
         * @returns {Array<{id: string, name: string, type: string}>} Array of questions
         */
        questions(){
            return this.categoryQuestions(this.categoryId) || [];
        },
        ...mapGetters(['categoryQuestions','categoriesValue'])
    },
    props: {
        categoryId: {
            type: String,
            required: true
        }
    }
};